import React, { useState, useRef } from "react";
import styles from "./ClientHorsesTab.module.css";
import i18n from "../../Services/i18n";
import { useToasts } from "../../LayoutComponents/ToastContext";
import { useModal } from "../../Context/ModalContext";
import HorseService from "../../Services/horseService";
import HorseQuickForm from "../QuickFormComponents/HorseQuickForm/HorseQuickForm";
import ListCardContainer from "../ListCard/ListCardContainer";
import { usePrivileges } from "../../Context/PrivilegeContext";
import PrivilegeValidationService from "../../Services/privilegeValidationService";

const ClientHorsesTab = ({ client, reloadDetailClient }) => {
  const horseListRef = useRef({});
  const [selectedHorse, setSelectedHorse] = useState();
  const [formKeys, setFormKeys] = useState({ formHorse: 0 });

  const { addToast } = useToasts();
  const { openModal } = useModal();
  const { privileges } = usePrivileges();
  const horseQuickFormRef = useRef(null);

  const handleAddHorseClick = async () => {
    const currentFormKey = formKeys.formHorse;

    if (!PrivilegeValidationService.CanAddHorse(await privileges(), client.horses.length)) {
      addToast(
        i18n.t("Privilege.ValidationError.MaxServicesByClient"),
        "PrivilegeValidationFailed",
        "ERROR",
        true,
      );
      return;
    }

    openModal({
      title: i18n.t("BoardServiceClient.HorseQuickCreate"),
      form: "formHorse",
      wideMode: true,
      hideSaveButton: true,
      hideSaveAndCloseButton: false,
      content: (
        <HorseQuickForm
          key={currentFormKey}
          ref={horseQuickFormRef}
          client={client}
          wideMode={true}
        />
      ),
      canClose: async () => {
        const isDirty = horseQuickFormRef.current?.isDirty?.();
        if (!isDirty) return true;

        return window.confirm(i18n.t("Modal.UnsavedChangesConfirm"));
      },
      onSave: async () => {
        try {
          const isValid = horseQuickFormRef.current.validate();
          if (!isValid) return;

          const id = await HorseService.QuickCreate(horseQuickFormRef.current.getFormData());
          if (!id) return false;

          reloadDetailClient(client);
          return true;
        } catch (ex) {
          addToast(i18n.t("Generic.ServerError"), "BACKENDERROR", "ERROR", true);
          return false;
        }
      },
      onClose: (formName) => {
        setFormKeys((prevKeys) => ({
          ...prevKeys,
          [formName]: prevKeys[formName] + 1,
        }));
      },
    });
  };

  return (
    <div className={styles.horses}>
      <ListCardContainer
        addButtonAction={handleAddHorseClick}
        hideHeader={true}
        isLoading={false}
        hideEmptyHorseCard={true}
        refresh={() => reloadDetailClient(client, true)}
        dataItems={client?.horses ?? []}
        onSelect={setSelectedHorse}
        selectedItemExternalId={selectedHorse?.externalId ?? client.externalId}
        type="horse"
        ref={horseListRef}
        storageId={"ClientHorseTab.Horse"}
      />
    </div>
  );
};

export default ClientHorsesTab;
